import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "earth"
const EarthIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 3C7.806 3 4.283 5.868 3.283 9.75H8.903L9.113 9.93 11.738 12.18 12 12.406V15.962L9.179 20.546C10.066 20.839 11.014 21 12 21 15.78 21 19.013 18.669 20.346 15.367L19.263 16.017 15.716 10.5H13.19L11.25 8.56V6.126L12.75 4.125H16.357C15.066 3.409 13.581 3 12 3M3.031 11.25Q3.001 11.62 3 12C3 15.447 4.938 18.44 7.783 19.951L10.5 15.538V13.094L8.348 11.25zM12.75 6.624V7.939L13.81 9H16.535L19.737 13.983 20.908 13.28Q21 12.653 21 12C21 9.693 20.131 7.59 18.704 5.997Q18.654 5.995 18.603 5.985L16.8 5.625H13.499z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default EarthIcon
